import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Header, Grid, Icon, Popup } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { colors } from 'utils/colors';
import { Portfolio, Planning } from 'actions';
import { NavigationButtons } from '../components';
import { ErrorLabel } from '../../../../components';

const WEALTH_OPTIONS = [
  { key: '0.5', value: 0.5, label: '50%', accent: '#b8c4ff' },
  { key: '0.75', value: 0.75, label: '75%', accent: '#6b8cff' },
  { key: '0.9', value: 0.9, label: '90%', accent: '#1f2e86' },
];

const GAUGE_RADIUS = 48;
const GAUGE_LENGTH = Math.PI * GAUGE_RADIUS;
const formatMoney = (amount) =>
  `$${Number(amount).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

function Gauge({ value, label, accent }) {
  return (
    <GaugeWrapper>
      <svg viewBox="0 0 120 60" width="100%" role="img" aria-label={label}>
        <path
          d="M 12 60 A 48 48 0 0 1 108 60"
          fill="none"
          stroke="#eeeeee"
          strokeWidth="14"
        />
        <path
          d="M 12 60 A 48 48 0 0 1 108 60"
          fill="none"
          stroke={accent}
          strokeWidth="14"
          strokeDasharray={`${value * GAUGE_LENGTH} ${GAUGE_LENGTH}`}
        />
        <text
          x="60"
          y="60"
          textAnchor="middle"
          fontSize="19"
          fontWeight="700"
          fill="#1f2e86"
        >
          {label}
        </text>
      </svg>
    </GaugeWrapper>
  );
}

Gauge.propTypes = {
  value: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  accent: PropTypes.string.isRequired,
};

class Result extends Component {
  constructor(props) {
    super(props);
    this.state = { prevInputChanged: false, error: '' };
  }

  componentWillMount = () => {
    const { dispatch, modelPortfolios } = this.props;

    if (!modelPortfolios.length) {
      dispatch(Portfolio.fetchModel());
    }
  };

  componentDidMount = () => {
    if (localStorage.getItem('cacheInputChanged')) {
      this.setState({ prevInputChanged: true });
    }
  };

  componentWillUnmount = () => {
    const { history, result } = this.props;

    if (history.location.pathname.includes('personal_details') && result) {
      localStorage.setItem('cacheWR', JSON.stringify(result));
    }
  };

  setTargetSaving = (isNewBlueprint) => {
    const {
      match,
      annuityRate,
      history,
      dispatch,
      result,
      targ,
      modelPortfolios,
    } = this.props;
    const cacheTS = JSON.parse(localStorage.getItem('cacheTS'));
    const cacheSR = JSON.parse(localStorage.getItem('cacheSR'));

    if (annuityRate || annuityRate === 0) {
      dispatch(
        Planning.updateBlueprintData('targetWealth', { targ: result.Annuity })
      );
    } else {
      dispatch(Planning.updateBlueprintData('targetWealth', { targ }));
    }

    if (isNewBlueprint) {
      dispatch(Planning.updateBlueprintData('targetSaving', {}));

      return history.push(
        `/planning/blueprint/${match.params.id}/target_saving`
      );
    }

    if (this.isTargOrHorzChanged()) {
      const { savings_portfolio } = cacheTS || {};
      const selectedPortfolio = modelPortfolios.find(
        (port) => Number(port.id) === Number(savings_portfolio)
      );

      if (!localStorage.getItem('cacheWealthChanged')) {
        localStorage.setItem('cacheWealthChanged', true);
      }

      if (!selectedPortfolio) {
        dispatch(Planning.updateBlueprintData('targetSaving', {}));

        return history.push(
          `/planning/blueprint/${match.params.id}/target_saving`
        );
      }

      dispatch(
        Planning.updateBlueprintData('targetSaving', {
          ...cacheTS,
        })
      );
      dispatch(
        Planning.updateBlueprintData('savingResult', {
          ...cacheSR,
        })
      );
      return history.push(
        `/planning/blueprint/${match.params.id}/target_saving`
      );
    }
    dispatch(
      Planning.updateBlueprintData('targetSaving', {
        ...cacheTS,
      })
    );
    dispatch(
      Planning.updateBlueprintData('savingResult', {
        ...cacheSR,
      })
    );

    return history.push(`/planning/blueprint/${match.params.id}/target_saving`);
  };

  hasEmptyTarg = (values) => {
    if (values === null || values === undefined) {
      this.setState({ error: 'Select one of the three scenarios' });

      return true;
    }

    return false;
  };

  isTargOrHorzChanged = () => {
    const { match, targ, horz, cacheBlueprint } = this.props;
    const { targetWealth } = JSON.parse(cacheBlueprint) || {};

    if (match.params.id === 'new' || !targetWealth) {
      return false;
    }

    return targetWealth.horz !== horz || targetWealth.targ !== targ;
  };

  updatetarg = (e, { value }) => {
    this.props.dispatch(
      Planning.updateBlueprintData('targetWealth', { targ: value })
    );
    this.setState({ error: '' });

    const cacheTW = {
      ...JSON.parse(localStorage.getItem('cacheTW')),
      targ: value,
    };
    localStorage.setItem('cacheTW', JSON.stringify(cacheTW));

    if (!localStorage.getItem('cacheTargetChanged')) {
      localStorage.setItem('cacheTargetChanged', true);
    }
  };

  nextStep = () => {
    const { match, dispatch, data } = this.props;

    if (this.hasEmptyTarg(data.targetWealth.targ)) {
      return false;
    }

    dispatch(Planning.nextSubPage('targetWealth'));
    dispatch(
      Planning.updateBlueprintData('targetSaving', { currentSubPage: 1 })
    );

    return this.setTargetSaving(match.params.id === 'new');
  };

  isChangedFromPrevious = () => {
    const { match, currentBlueprint, cacheWR } = this.props;
    const currentWR = (JSON.parse(currentBlueprint) || {}).wealthResult || {};

    if (match.params.id === 'new') {
      return false;
    }

    if (currentWR.Annuity) {
      return currentWR.Annuity !== cacheWR.Annuity;
    }

    return Object.keys(currentWR).reduce((diff, percentage) => {
      if (currentWR[percentage] !== cacheWR[percentage]) {
        return true || diff;
      }

      return diff;
    }, false);
  };

  renderAnnuity = () => {
    const { result } = this.props;
    const { retAge } = this.props.data.personalDetails || {};
    const pv =
      result.target_wealth_pv && result.target_wealth_pv.Annuity !== undefined
        ? result.target_wealth_pv.Annuity
        : null;

    return (
      <BlueprintContent>
        <ResultContent>
          <ResultTitle>
            <Header size="medium" style={{ margin: '0 0 1rem' }}>
              Target Wealth at Retirement
              <FutureValueLabel>Future (Nominal) Value</FutureValueLabel>
            </Header>
            <Description>
              Since your post-retirement portfolio is risk-free (i.e. fixed rate
              of return), how much you need by your retirement age is a certain
              amount.
            </Description>
          </ResultTitle>
          {this.isChangedFromPrevious() && (
            <div style={{ marginTop: '1.5rem', color: colors.red }}>
              Note: These values have been updated to reflect changes made in
              the previous section(s).
            </div>
          )}
          <Grid style={{ margin: '1rem 0' }}>
            <Grid.Row columns={3} style={{ padding: 0 }}>
              <Grid.Column />
              <Grid.Column>
                <AnnuityCard>
                  <CardLabel>
                    {retAge
                      ? `Target wealth at age ${retAge}`
                      : 'Target wealth'}
                    {pv !== null ? (
                      <Popup
                        trigger={
                          <Icon
                            name="question circle outline"
                            style={{ color: 'dimgrey', marginLeft: '3px' }}
                          />
                        }
                        content={`Equivalent to ${formatMoney(
                          pv
                        )} in today's dollars.`}
                        wide
                        position="top center"
                      />
                    ) : null}
                  </CardLabel>
                  <CardValue>{formatMoney(result.Annuity)}</CardValue>
                </AnnuityCard>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </ResultContent>
        <NavigationButtons
          handleNextPage={this.nextStep}
          showPreviousButton={false}
          nextButtonText="Next"
        />
        <div style={{ clear: 'both' }} />
      </BlueprintContent>
    );
  };

  renderWealth = () => {
    const { result, targ } = this.props;
    const { error, prevInputChanged } = this.state;
    const { retAge } = this.props.data.personalDetails || {};
    const base = result['0.5'];

    return (
      <BlueprintContent>
        <ResultContent>
          <ResultTitle>
            <Header size="medium" style={{ margin: '0 0 1rem' }}>
              Target Wealth at Retirement
              <FutureValueLabel>Future (Nominal) Value</FutureValueLabel>
            </Header>
            <Description>
              Each target wealth amount corresponds to a likelihood of
              sustaining the client’s retirement spending. Results are based on
              10,000 simulations of the selected portfolio.
            </Description>
          </ResultTitle>
          {this.isChangedFromPrevious() && (
            <div style={{ marginTop: '1.5rem', color: colors.red }}>
              Note: These values have been updated to reflect changes made in
              the previous section(s).
            </div>
          )}
          <Header
            size="small"
            style={{
              margin: '1.5rem 0 0',
              textAlign: 'center',
              fontSize: '16px',
            }}
          >
            Likelihood of Success
            <Popup
              trigger={
                <Icon
                  name="question circle outline"
                  style={{
                    color: 'dimgrey',
                    marginLeft: '3px',
                    fontSize: '1em',
                    marginBottom: '5px',
                  }}
                />
              }
              position="right center"
              content="The probability of being able to sustain your net spending needs in retirement."
            />
          </Header>
          <Grid style={{ margin: '0.5rem 0 1rem' }}>
            <Grid.Row columns={3}>
              {WEALTH_OPTIONS.map((option) => {
                const amount = result[option.key];
                const hasAmount = amount !== undefined && amount !== null;
                const selected = targ === amount && prevInputChanged === false;
                const pv = result.target_wealth_pv
                  ? result.target_wealth_pv[option.key]
                  : null;
                const diff =
                  hasAmount && option.key !== '0.5' && base !== undefined
                    ? amount - base
                    : null;

                return (
                  <Grid.Column
                    key={option.key}
                    onClick={() => {
                      this.updatetarg(null, { value: amount });
                      this.setState({ prevInputChanged: false });
                    }}
                  >
                    <ResultCard selected={selected} accent={option.accent}>
                      <Gauge
                        value={option.value}
                        label={option.label}
                        accent={option.accent}
                      />
                      <CardDivider />
                      <CardLabel>
                        {retAge
                          ? `Target wealth at age ${retAge}`
                          : 'Target wealth'}
                        {pv !== null && pv !== undefined ? (
                          <Popup
                            trigger={
                              <Icon
                                name="question circle outline"
                                style={{ color: 'dimgrey', marginLeft: '3px' }}
                              />
                            }
                            content={`Equivalent to ${formatMoney(
                              pv
                            )} in today's dollars.`}
                            wide
                            position="top center"
                          />
                        ) : null}
                      </CardLabel>
                      <CardValue>
                        {hasAmount ? formatMoney(amount) : '--'}
                      </CardValue>
                      {diff !== null ? (
                        <CardSub>{`+${formatMoney(diff)} vs. 50%`}</CardSub>
                      ) : (
                        <div style={{ height: '20px' }} />
                      )}
                      <SelectIndicator selected={selected}>
                        <Icon
                          name={selected ? 'check' : 'circle outline'}
                          style={{ marginRight: '0.4rem', marginBottom: '5px' }}
                        />
                        {selected ? 'Selected' : 'Select'}
                      </SelectIndicator>
                    </ResultCard>
                    {option.key === '0.75' ? (
                      <ErrorLabel
                        className="bottom"
                        style={{ top: '15.5rem' }}
                        msg={error}
                      />
                    ) : null}
                  </Grid.Column>
                );
              })}
            </Grid.Row>
          </Grid>
        </ResultContent>

        <NavigationButtons
          handleNextPage={this.nextStep}
          showPreviousButton={false}
          nextButtonText="Next"
        />

        <div style={{ clear: 'both' }} />
      </BlueprintContent>
    );
  };

  render() {
    const { result, match } = this.props;

    if (!result) {
      return null;
    }

    return result.Annuity !== undefined && result.Annuity !== null
      ? this.renderAnnuity(match.params.id)
      : this.renderWealth(match.params.id);
  }
}

Result.propTypes = {
  result: PropTypes.object,
  horz: PropTypes.number,
  targ: PropTypes.number,
  annuityRate: PropTypes.number,
  history: PropTypes.object,
  match: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  currentBlueprint: PropTypes.string,
  cacheBlueprint: PropTypes.string,
  cacheWR: PropTypes.object,
  modelPortfolios: PropTypes.array,
  data: PropTypes.object,
};

Result.defaultProps = {
  result: null,
  horz: null,
  targ: null,
  annuityRate: null,
  currentBlueprint: null,
  cacheBlueprint: null,
  cacheWR: {},
  history: {},
  match: {},
  modelPortfolios: [],
  data: {},
};

export default connect((state) => ({
  modelPortfolios: state.Portfolio.model,
  currentBlueprint: localStorage.getItem('pwpa-blueprint'),
  cacheBlueprint: localStorage.getItem('cache-pwpa-blueprint'),
  isFetching: state.Planning.isFetching,
}))(Result);

const BlueprintContent = styled.div`
  padding: 2.5rem;
  background-color: white;
  border-radius: 8px;
  margin-bottom: 2rem;
  div {
    .header {
      .sub.header {
        font-size: 1.2rem;
      }
    }
  }
`;

const ResultContent = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: auto;
  text-align: left;
`;

const ResultTitle = styled.div`
  text-align: left;
`;

const FutureValueLabel = styled.span`
  margin-left: 0.5rem;
  font-size: 15px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
`;

const Description = styled.div`
  max-width: 55rem;
  font-size: 15px;
  line-height: 1.7;
  color: rgba(0, 0, 0, 0.6);
`;

const AnnuityCard = styled.div`
  width: 100%;
  max-width: 400px;
  margin: 1.5rem auto;
  padding: 1.5rem 1.25rem;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fff;
  text-align: center;
`;

const ResultCard = styled.div`
  min-height: 100%;
  padding: 1.5rem 1.25rem;
  border: 1px solid ${(props) => (props.selected ? props.accent : '#e5e7eb')};
  border-radius: 8px;
  background: ${(props) => (props.selected ? '#f4f3ff' : '#fff')};
  text-align: center;
  cursor: pointer;
  box-shadow: ${(props) =>
    props.selected ? `0 0 0 1px ${props.accent}` : 'none'};
  transition: border-color 0.15s ease, background 0.15s ease,
    box-shadow 0.15s ease;

  &:hover {
    border-color: ${(props) => props.accent};
  }
`;

const GaugeWrapper = styled.div`
  position: relative;
  width: 204px;
  max-width: 100%;
  margin: 0 auto;
`;

const CardDivider = styled.div`
  height: 1px;
  margin: 1.25rem 0 1rem;
  background: rgba(0, 0, 0, 0.08);
`;

const CardLabel = styled.div`
  font-size: 15px;
  color: rgba(0, 0, 0, 0.6);
`;

const CardValue = styled.div`
  margin: 0.35rem 0 0.25rem;
  color: #1a1a1a;
  font-size: 2rem;
  font-weight: 700;
`;

const CardSub = styled.div`
  color: rgba(0, 0, 0, 0.55);
  font-size: 14px;
`;

const SelectIndicator = styled.div`
  display: inline-flex;
  align-items: center;
  margin-top: 1rem;
  padding: 0.5rem 1.1rem;
  border: 1px solid ${(props) => (props.selected ? colors.blue : '#d6d9de')};
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.75);
  background: ${(props) => (props.selected ? '#e8ebff' : '#fff')};
`;
